export default "__VITE_ASSET__B2p0cseg__"